import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../../types'
import { CmsConverterService, defaultLinkData } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedProductsLinkConverter extends CmsConverterService<PanelRowRelatedProductsLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      link: formData.st_panel_row_related_products_link ?? defaultLinkData
    }
  }
}

export const PANEL_ROW_RELATED_PRODUCTS_LINK_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedProductsLinkData>>('PanelRowRelatedProductsLinkConverter')

export interface PanelRowRelatedProductsLinkData extends ConvertedComponentData {
  link: LinkData;
}
